(function (angular) {
  "use strict";

  var TRANSITION_DURATION_MS = 250;

  angular.module("Toyota.Directives").directive("tyLinkedExpandos", [
    "$timeout",
    function ($timeout) {
      function repaint($element, repaintState) {
        var $contentEls = $element.find("[data-ty-linked-expandos-content]");
        $contentEls.each(function () {
          var $content = angular.element(this);
          // Measure what the $content height would be if it were open
          $content.css({ "max-height": "9999px", "visibility": "hidden", "transition": "none" });
          var startContentRect = $content.get(0).getBoundingClientRect();
          var contentHeight = startContentRect.bottom - startContentRect.top;

          $content.css({
            "max-height": repaintState.isOpen ? "0" : contentHeight,
            "visibility": "",
            "transition": "none",
          });

          $timeout(function () {
            $content.css({ transition: "" });
            $content.toggleClass("is-expanded", repaintState.isOpen);
            $content.css("max-height", repaintState.isOpen ? contentHeight : "0");

            $timeout(function () {
              $content.css("max-height", "");
              $content.css("overflow", repaintState.isOpen ? "visible" : "hidden");
            }, TRANSITION_DURATION_MS);
          });
        });
      }

      var controller = [
        "$scope",
        "$element",
        function ($scope, $element) {
          var ctl = this;

          ctl.toggle = function () {
            $scope.linkedExpandos.isOpen = !$scope.linkedExpandos.isOpen;
            repaint($element, { isOpen: $scope.linkedExpandos.isOpen });
          };
        },
      ];

      return {
        restrict: "A",
        scope: true,
        controllerAs: "tyLinkedExpandos",
        controller: controller,
        link: function ($scope, $element, $attrs) {
          $scope.linkedExpandos = {
            isOpen: $attrs.tyLinkedExpandosStartOpen === "true",
          };
        },
      };
    },
  ]);
})(window.angular);
